import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CallbackPageComponent } from './pages/callback-page/callback-page.component';

const routes: Routes = [{ path: 'callback', component: CallbackPageComponent }];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class AuthenticationRoutingModule {}
